/* assets/rora-gallery.config.js */
/**
 * 編輯說明：
 * 1) path：貼「文章的網址 path」（例：/blogs/journal/ori-collection）
 * 2) targets：要被拉進兩欄畫廊的圖片檔名片段（含副檔名；可只有片段）
 * 3) productNames / productLinks：依畫面從上到下、左到右排序（可留空）
 *
 * 新增/修改時，避免刪到最外層的 window.RORA_GALLERY_CONFIG 賦值。
 */
window.RORA_GALLERY_CONFIG = [
  {
    path: '/blogs/新聞/late-summer-reverie-初秋序曲',
    targets: ['P1341045_2.jpg', 'P1352272.jpg', 'P1352310.jpg', 'P1352270-1.jpg'],
    productNames: [
      'Iva Ring │ 初熟 戒指',
      'Ori Ring │ 果穗 雙層戒指',
      'Ori Earrings │ 果穗 耳環',
      'Ori Necklace │ 果穗 項鍊'
    ],
    productLinks: [
      '/products/iva-ring',
      '/products/ori-ring',
      '/products/ori-earrings',
      '/products/ori-necklace'
    ]
  },
  {
    path: '/blogs/新聞/petals-pearls',
    targets: ['P1341032.jpg', 'P1341009_1.jpg', 'P1341009_1_cf91b77c-73c9-45f1-9207-fd31533b8230.jpg', 'P1341342.jpg'],
    productNames: [
        'Bloomy Ring │ 雙花開口戒',
        'Bloomy Earrings │ 雙花耳環', 
        'Lumy Earrings │ 珍珠耳環', 
        'Bloomy Necklace │ 花鑽項鍊'
    ],
    productLinks: [
        '/products/bloomy-necklace',
        '/products/bloomy-earrings', 
        '/products/lumy-pearl-earrings', 
        '/products/bloomy-necklace'
    ]
  },
   {
    path: '/blogs/新聞/fortune',
    targets: ['fortunering-02.jpg', 'fortuneearrings-01.jpg', 'fortunebracelet-02.jpg', 'fortunehaircuff-01'],
    productNames: [
        'Fortune Ring │ 馬蹄形戒指',
        'Fortune Earrings │ 馬蹄形耳環', 
        'Fortune Bracelet │ 馬蹄形手鍊', 
        'Fortune Hair Cuff │  馬蹄形髮圈'
    ],
    productLinks: [
        '/products/fortune-ring',
        '/products/fortune-earrings', 
        '/products/fortune-bracelet', 
        '/products/fortune-hair-cuff'
    ]
  },
  // {
  //   path: '/blogs/新聞/mbti',
  //   targets: ['P1338618_-2.jpg', 'ESFP.jpg', 'ESFJ-2.jpg', 'P1338504.jpg'],
  //   productNames: [
  //       'MBTI │ Diplomats 外交家項鍊',
  //       'MBTI │ Explorers 探險家項鍊', 
  //       'MBTI │ Sentinels 守護者項鍊', 
  //       'MBTI │ Analysts 分析家項鍊'
  //   ],
  //   productLinks: [
  //       '/products/mbti-necklace-diplomats',
  //       '/products/mbti-necklace-explorers', 
  //       '/products/mbti-necklace-sentinels', 
  //       '/products/mbti-necklace-analysts'
  //   ]
  // }
];
